<template>
    <div>
        <HeadBar :title="title" :placeholder="false" :bg="'transparent'"></HeadBar>
        <!-- <img style="width: 100%;" :src="require('@/assets/img/1231.jpg')" /> -->
        <van-swipe @change="onChange">
            <van-swipe-item v-for="(item, index) in ulevelList" :key="index">
                <div class="cardBox">
                    <van-row>
                        <van-col span="24" class="ulevelcol">
                            <img draggable="false" :src="require('@/assets/img/re' + item.ul + '.png')" />
                        </van-col>
                    </van-row>
                </div>
            </van-swipe-item>
            <template #indicator>
                <div class="custom-indicator">
                    当前级别 {{ ul }}/{{ ulevelList.length }} 可选
                </div>
            </template>
        </van-swipe>
        <div class="form">
            <div class="cardBox form-list">
                <div class="cardContent border-radius">
                    <van-field label="级别" :value="ulname" readonly />
                    <van-field v-model.trim="bdname" label="服务中心" placeholder="请输入服务中心" />
                    <van-field v-model.trim="recode" label="推广码" placeholder="请输入推广码" />
                    <van-field v-model.trim="fname" label="接点人" placeholder="请输入接点人" />
                    <van-field label="区域" v-model="tpname" placeholder="请选择所在区域" is-link readonly @click="areaShow = true" />
                    <van-popup v-model="areaShow" round position="bottom" :style="{ height: '30%' }">
                        <van-picker title="所在区域" show-toolbar :columns="areacolumns" value-key="tpname" @cancel="AreaCancel" @confirm="AreaConfirm" />
                    </van-popup>
                    <van-field v-model.trim="userid" label="用户名" placeholder="请输入用户名" />

                    <van-field v-model.trim="password" type="password" placeholder="请输入密码" label="密码" />
                    <van-field v-model.trim="password2" type="password" placeholder="请输入支付密码" label="支付密码" />
                    <van-field v-model.trim="username" label="姓名" placeholder="请输入姓名" />
                    <van-field v-model.trim="usertel" label="手机号" placeholder="请输入手机号" />
                    <!-- <van-field v-model="code" center clearable label="验证码" placeholder="请输入短信验证码">
					<template #button>
						<van-button size="small" type="primary" @click="sendcode()">{{send}}</van-button>
					</template>
          </van-field>-->
                </div>
            </div>
        </div>
        <div class="zhucepage">
            <van-submit-bar :price="0" button-text="下一步" @submit="xiayibu">
                <van-checkbox v-model="checked">
                    我已清楚并同意
                    <span class="regist-protocol" @click="show = true">注册协议</span>
                </van-checkbox>
            </van-submit-bar>
        </div>
        <van-dialog v-model="show" title="注册协议" show-cancel-button @cancel="DoNotAgree" @confirm="Agree" confirm-button-text="同意" cancel-button-text="不同意">
            <div class="reginfo" v-html="registInfo"></div>
        </van-dialog>

        <van-popup v-model="xiayibuShow" :style="{ width:'100%', height: '100%',background:'#F7F7F7' }" position="right">
            <van-nav-bar :fixed="true" :border="false" :style="'background:#FE609D'" :title="title" left-arrow @click-left="xiayibuShow = false" />
            <div style="height:50px;"></div>
            <div class="scroll-wrap">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :offset="10" :immediate-check="true" @load="onLoad">
                    <div class="cardBox">
                        <div class="cardContent">
                            <van-cell @click="AddressShow = true" v-show="AddressInfo.areaCode.length == 0" title="请选择收货地址" :border="false" readonly is-link />
                            <van-cell @click="AddressShow = true" v-show="AddressInfo.areaCode.length > 0" :title="AddressInfo.name + ' ' + AddressInfo.tel" :label="AddressInfo.province + AddressInfo.city + AddressInfo.county + AddressInfo.addressDetail" :border="false" readonly center is-link />
                            <van-popup v-model="AddressShow" :style="{ width:'100%', height: '70%' }" position="bottom">
                                <van-address-edit :area-list="areaList" :address-info="AddressInfo" show-set-default :area-columns-placeholder="['请选择', '请选择', '请选择']" @save="onSave" />
                            </van-popup>
                        </div>
                    </div>
            
                    <div class="cardBox" v-for="(item, index) in goodslist" :key="index">
                        <div class="cardContent">
                            <van-row>
                                <van-col span="6">
                                    <img :src="getimg(item.goodsimg)" style="width: 100%" />
                                </van-col>
                                <van-col span="16" class="goodsname">{{ item.goodsname }}</van-col>
                                <van-col span="16" class="goodscontent van-ellipsis">{{ item.prompt }}</van-col>
                                <van-col span="8" class="goodsprice">¥{{ item.goodsprice }}</van-col>
                                <van-col span="8" class="count">
                                    <van-stepper v-model="item.num" min="0" @change="jsPrice" />
                                </van-col>
                            </van-row>
                        </div>
                    </div>
                </van-list>
            </div>
            <van-submit-bar :price="sumPrice" button-text="注册" @submit="Users_Register">
            </van-submit-bar>
        </van-popup>
    </div>
</template>

<script>
import areaList from "@/assets/js/area.js";
import "@vant/touch-emulator";
import HeadBar from "@/components/HeadBar";
import Vue from "vue";
import {
    Stepper,
    Field,
    SubmitBar,
    Button,
    Area,
    Popup,
    Picker,
    AddressEdit,
    Checkbox,
    Dialog,
    Swipe,
    SwipeItem,
    Cell,
    List
} from "vant";

Vue.use(Stepper);
Vue.use(Field);
Vue.use(SubmitBar);
Vue.use(Button);
Vue.use(AddressEdit);
Vue.use(Area);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Checkbox);
Vue.use(Dialog);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Cell);
Vue.use(List);
export default {
    components: {
        HeadBar,
    },
    data() {
        return {
            title: document.title,
            cacheToken: "",
            bdname: "",
            recode: "",
            fname: "",
            tp: 1,
            tpname: "A区",
            areaShow: false,
            areacolumns: [
                {
                    flex: 1,
                    values: [
                        {
                            tp: 1,
                            tpname: "A区",
                        },
                        {
                            tp: 2,
                            tpname: "B区",
                        },
                        {
                            tp: 3,
                            tpname: "C区",
                        },
                        {
                            tp: 4,
                            tpname: "D区",
                        },
                        {
                            tp: 5,
                            tpname: "E区",
                        },
                    ],
                    defaultIndex: 0,
                },
            ],
            userid: "",
            username: "",
            usertel: "",
            password: "",
            password2: "",
            code: "",
            send: "发送",
            checked: false,
            show: false,
            registInfo: "",
            ulevelList: [], //等级名称集合
            ul: "", //选择的等级
            ulname: "", //选择的等级名称
            ulindex: 0, //用于注册金额集合与等级名称相匹配的下标

            xiayibuShow: false,
            AddressShow: false,
            areaList,
            AddressInfo: {
                //收货人信息初始值
                name: "", //姓名
                tel: "", //电话
                province: "", //省份
                city: "", //城市
                county: "", //区县
                areaCode: "", //地址code：ID
                addressDetail: "", //详细地址
                isDefault: true, //是否选择默认
            },

            goodslist: [],
            sumPrice: 0,
            pageIndex: 1,
            pageSize: 10,
            loading: false,
            finished: true
        };
    },
    created() {
        this.cacheToken = Math.random();
        if (this.$route.query.rr) {
            this.recode = this.$route.query.rr;
        }
        if (this.$utils.GetQueryString("rr")) {
            this.recode = this.$utils.GetQueryString("rr");
        }
        if (this.recode) {
            this.Users_Leader();
        }
        this.getulevel();
        this.GetRegistInfo();
        this.getgoods();
    },
    methods: {
		xiayibu(){
			this.AddressInfo.name = this.username;
			this.AddressInfo.tel = this.usertel;
			this.xiayibuShow = true;
		},
        Users_Register: function () {
            let _this = this;
            if (_this.recode == "") {
                _this.$toast.fail("推广码不能为空");
                return;
            }
            if (_this.userid == "") {
                _this.$toast.fail("用户名不能为空");
                return;
            }
            if (_this.username == "") {
                _this.$toast.fail("姓名不能为空");
                return;
            }
            if (_this.usertel == "") {
                _this.$toast.fail("手机号不能为空");
                return;
            }
            if (_this.password == "") {
                _this.$toast.fail("密码不能为空");
                return;
            }
            if (_this.password2 == "") {
                _this.$toast.fail("支付密码不能为空");
                return;
            }
            if (_this.checked == false) {
                _this.$toast.fail("请先同意注册协议");
                return;
            }

            if (_this.AddressInfo.username == "") {
                _this.$toast.fail("请输入收货人姓名");
                return;
            }
            if (_this.AddressInfo.usertel == "") {
                _this.$toast.fail("请输入收货人电话");
                return;
            }
            if (_this.AddressInfo.areaCode == "") {
                _this.$toast.fail("请选择收货地址");
                return;
            }
            if (_this.AddressInfo.addressDetail == "") {
                _this.$toast.fail("请输入详细地址");
                return;
            }

            var glist = [];
            var jine = 0;
            _this.goodslist.forEach((item) => {
                if (item.num > 0) {
                    jine += item.num * item.scprice;
                    var goods = {
                        id: item.id,
                        num: item.num,
                    };
                    glist.push(goods);
                }
            });
            if (jine <= 0) {
                _this.$toast({
                    message: "请选择商品",
                    position: "bottom",
                    duration: 1500,
                });
                return;
            }

            let _loadtoast = _this.$toast.loading({
                message: "正在注册...",
                duration: 0, // 持续展示 toast
            });
            _this.$request.post(
                "api/Users/Register",
                {
                    cacheToken: _this.cacheToken,
                    bdname: _this.bdname,
                    recode: _this.recode,
                    fname: _this.fname,
                    tp: _this.tp,
                    userid: _this.userid,
                    password: _this.password,
                    password2: _this.password2,
                    username: _this.username,
                    usertel: _this.usertel,
                    ulevel: _this.ul,

                    AddressInfoName: _this.AddressInfo.name,
                    AddressInfoTel: _this.AddressInfo.tel,
                    AddressInfoProvince: _this.AddressInfo.province,
                    AddressInfoCity: _this.AddressInfo.city,
                    AddressInfoCounty: _this.AddressInfo.county,
                    AddressInfoAreaCode: _this.AddressInfo.areaCode,
                    AddressInfoAddressDetail: _this.AddressInfo.addressDetail,
                    AddressInfoIsDefault: _this.AddressInfo.isDefault ? 1 : 0,

                    glist: JSON.stringify(glist),
                },
                (res) => {
                    if (res.data.code == 0) {
                        _this.$dialog.alert({
                            title: "提示",
                            message: res.data.msg,
                        });
                        return;
                    }
                    _this.userid = "";
                    _this.password = "";
                    _this.password2 = "";
                    _this.username = "";
                    _this.usertel = "";
                    _this.$utils.setloc("reg_fname", "");
                    _this.$utils.setloc("reg_tp", "");

                    _loadtoast.clear();

                    _this.$toast({
                        message: res.data.msg,
                        position: "middle",
                        duration: 2000,
                    });
                }
            );
        },
        onSave(e) {
            this.AddressInfo.name = e.name;
            this.AddressInfo.tel = e.tel;
            this.AddressInfo.province = e.province;
            this.AddressInfo.city = e.city;
            this.AddressInfo.county = e.county;
            this.AddressInfo.addressDetail = e.addressDetail;
            this.AddressInfo.isDefault = e.isDefault;
            this.AddressInfo.areaCode = e.areaCode;
            this.AddressShow = false;
        },
        getgoods: function () {
            // 查询商品
            var _this = this;
            _this.$request.post(
                "Api/ShopGoods/List",
                {
                    goodstype: 0,
                    pageIndex: _this.pageIndex,
                    pageSize: _this.pageSize,
                    ishome: 0
                },
                (res) => {
                    _this.loading = false
                    if (res.data.code == 0) {
                        _this.$dialog.alert({
                            title: "提示",
                            message: res.data.msg,
                        });
                        return;
                    }
                    var list = res.data.data;
                    list.forEach((item) => {
                        item["num"] = 0;
                        item.goodsimg = item.goodsimg.split(",")[0];
                    });
                    if(list.length > 0) {
                        _this.finished = false
                    } else {
                        _this.finished = true
                    }
                    _this.goodslist.push(...list)
                    _this.jsPrice();
                },
                false
            );
        },
        jsPrice: function () {
            // 计算总价
            this.sumPrice = 0;
            this.goodslist.forEach((item) => {
                this.sumPrice += item.goodsprice * item.num * 100;
            });
        },

        getimg: function (img) {
            if (img != "" && img != null) {
                return this.$config.send_url + "Upload/" + img;
            }
        },
        GetRegistInfo() {
            var _this = this;
            _this.$request.post(
                "api/Article/Get",
                {
                    select_id: 8,
                },
                (res) => {
                    if (res.data.code == 0) {
                        _this.$dialog.alert({
                            title: "提示",
                            message: res.data.msg,
                        });
                        return;
                    }
                    _this.registInfo = res.data.data.articlecontent;
                }
            );
        },
        sendcode: function () {
            let _this = this;
            if (_this.send == "发送") {
                let i = 60;
                _this.send = i + "S";
                var timer = setInterval(function () {
                    i--;
                    _this.send = i + "S";
                    if (i <= 0) {
                        clearInterval(timer);
                        _this.send = "发送";
                    }
                }, 1000);

                if (this.usertel.length != 11) {
                    this.$toast.fail("请输入11位手机号码");
                    return;
                }

                let _usertel = "aaa" + this.usertel + "bbb";

                _this.$request.post(
                    "api/Sms/SendCode",
                    {
                        token: _this.$utils.getloc("token"),
                        userid: _this.$utils.getloc("userid"),
                        usertel: _usertel,
                    },
                    (res) => {
                        if (res.data.code == 0) {
                            _this.$dialog.alert({
                                title: "提示",
                                message: res.data.msg,
                            });
                            return;
                        }
                        _this.$toast({
                            message: res.data.msg,
                            position: "middle",
                            duration: 2000,
                        });
                    }
                );
            }
        },
        getulevel: function () {
            let _this = this;
            _this.$request.post(
                "api/Level/GetUlevelList",
                {},
                (res) => {
                    if (res.data.code == 0) {
                        _this.$dialog.alert({
                            title: "提示",
                            message: res.data.msg,
                        });
                        return;
                    }
                    res.data.data.forEach((item) => {
                    	var newitem = {
                    		ul: item.number,
                    		ulname: item.name + ' [' + item.tip + ']'
                    	};
                    	if (item.display) {
                    		_this.ulevelList.push(newitem);
                    	}
                    });
                    _this.ul = _this.regmin ? _this.regmin : 1; //选择等级默认值为最小等级限制
                    _this.ulname = _this.ulevelList[0].ulname; //选择等级默认值为最小等级限制
                },
                true
            );
        },
        Users_Leader: function () {
            let _this = this;
            _this.$request.post(
                "api/Users/Leader",
                {
                    recode: _this.recode,
                },
                (res) => {
                    if (res.data.code == 0) {
                        _this.$dialog.alert({
                            title: "提示",
                            message: res.data.msg,
                        });
                        return;
                    }
                    _this.bdname = res.data.data.bdname;
                    if (_this.$utils.getloc("reg_fname")) {
                        _this.fname = _this.$utils.getloc("reg_fname");
                        if (_this.$utils.getloc("reg_tp")) {
                            _this.tp = _this.$utils.getloc("reg_tp");
                            if (_this.tp == 1) {
                                _this.tpname = "A区";
                            } else if (_this.tp == 2) {
                                _this.tpname = "B区";
                            } else if (_this.tp == 3) {
                                _this.tpname = "C区";
                            } else if (_this.tp == 4) {
                                _this.tpname = "D区";
                            } else if (_this.tp == 5) {
                                _this.tpname = "E区";
                            }
                        }
                    }
                }
            );
        },
        AreaConfirm(value, index) {
            this.tp = value[0].tp;
            this.tpname = value[0].tpname;
            this.areaShow = false;
        },
        AreaCancel() {
            this.areaShow = false;
        },
        //同意协议
        Agree() {
            this.checked = true;
        },
        //不同意协议
        DoNotAgree() {
            this.checked = false;
        },
        onChange(index) {
            // console.log(index);
            this.ulindex = index;
            this.ul = this.ulevelList[index].ul;
            this.ulname = this.ulevelList[index].ulname;
            // console.log("ul：",this.ul)
        },
        onLoad() {
            this.loading = true
            this.pageIndex++
            this.getgoods()
        }
    },
};
</script>

<style scoped>
.form {
    position: relative;
}

.form-list {
    position: absolute;
    top: -55px;
    padding: 0;
    width: 100%;
}

.border-radius {
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    overflow: hidden;
}

/deep/.van-nav-bar .van-icon {
    color: #fff;
}

/* 隐藏价格 */
.zhucepage /deep/ .van-submit-bar__text > * {
    display: none;
}

.regist-protocol {
    color: #ea4747;
    text-decoration: underline;
}

.reginfo {
    max-height: 400px;
    padding: 10px;
    font-size: 14px;
    overflow: scroll;
}

.ulevelcol {
    position: relative;
}

.ulevelcol img {
    width: 100%;
    border-radius: 10px;
    float: left;
}

.custom-indicator {
    color: white;
    position: absolute;
    right: 14px;
    top: 10px;
    padding: 2px 5px;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.1);
}

.van-swipe {
    background-image: url(../../assets/img/2.png);
    background-size: 100%;
}

/deep/.van-submit-bar__button--danger {
	background: linear-gradient(to right, #FE609D, #FE609D);
}

/deep/.van-checkbox__icon--checked .van-icon {
	background-color: #FE609D;
	border-color: #FE609D;
}

/deep/.van-nav-bar .van-icon {
    color: #f2f3f5;
}
/deep/.van-nav-bar__title {
    color: #f2f3f5;
}

.goodsimg {
    text-align: center;
    padding: 0 5px;
}

.goodsimg img {
    border-radius: 10px;
}

.goodsname {
    font-size: 16px;
    padding-left: 10px;
    font-weight: 600;
}

.goodscontent {
    font-size: 14px;
    padding: 5px 0 0 10px;
    color: #888;
}

.goodsprice {
    padding: 5px 0 0 10px;
    color: red;
}

.count {
    padding-top: 5px;
    text-align: right;
}

.user {
    font-size: 14px;
    font-weight: 300;
}

.address {
    margin-top: 10px;
    font-size: 12px;
    color: #888;
}

.scroll-wrap {
    height: calc(100vh - 100px);
    overflow-y: auto;
}
</style>
